<template>
  <div class="index">
    <Main></Main>
  </div>
</template>

<script>
import Main from "./Main"

export default {
  components: {
    Main
  },
  data() {
    return {}
  },
  
}
</script>

<style>
.index {
  width: 100%;
  height: 100%;
}

</style>
